import { useEffect } from 'react';

export type AppToastVariant = 'success' | 'error' | 'info';

export interface AppToastState {
  message: string;
  variant: AppToastVariant;
}

export interface AppToastProps {
  toast: AppToastState | null;
  onDismiss: () => void;
}

const BASE_CLASSES =
  'fixed bottom-4 right-4 z-[70] flex items-center gap-3 rounded-lg px-4 py-3 shadow-lg text-sm font-semibold toast-enter max-w-sm';

const VARIANT_CLASSES: Record<AppToastVariant, string> = {
  success: 'bg-green-50 text-green-800 border border-green-200',
  error: 'bg-red-50 text-red-800 border border-red-200',
  info: 'bg-blue-50 text-blue-700 border border-blue-200',
};

export function AppToast({ toast, onDismiss }: AppToastProps) {
  // Auto-dismiss after 5000ms; cleans up on unmount or message change (Pattern 8).
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(onDismiss, 5000);
    return () => clearTimeout(id);
  }, [toast, onDismiss]);

  if (!toast) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`${BASE_CLASSES} ${VARIANT_CLASSES[toast.variant]}`}
    >
      {toast.message}
    </div>
  );
}
